import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import GoldButton from 'components/ui-kit/GoldButton/index'
import ErrorMessage from 'components/layout/ErrorMessage'
import { verifyTransactionPassword } from 'redux-thunk/thunk/user.thunk'
import { ROUTE_PATHS } from 'constants/index'

const PIN_REGEX = /^\d{6}$/

const FORM_CONTROL =
  'box-border h-12 w-full rounded-[0.625rem] border border-solid border-[var(--gray-80)] bg-[var(--gray-90)] px-3 py-[0.438rem] text-center text-lg tracking-[0.4em] text-[var(--white)] shadow-none outline-none placeholder:!text-[var(--gray-20)] placeholder:!tracking-normal focus:border-[var(--blue-300)] focus:outline-none'

const WithdrawTransactionPasswordModal = ({
  hasTransactionPassword,
  onClose,
  onVerified,
  onGoToSettings
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleVerify = async (event) => {
    event.preventDefault()
    if (!PIN_REGEX.test(pin)) {
      setError(t('transactionPasswordLength'))
      return
    }
    setSubmitting(true)
    setError('')
    try {
      await dispatch(verifyTransactionPassword({ transactionPassword: pin })).unwrap()
      onVerified(pin)
    } catch (err) {
      setError(typeof err === 'string' ? err : t('transactionPasswordLength'))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <CommonPopup
      classes='!z-[2010]'
      modalDialogClass='!max-w-[440px]'
      modalCloseHandler={onClose}
    >
      {hasTransactionPassword
        ? (
          <form onSubmit={handleVerify}>
            <h3 className='mb-2 text-lg font-bold uppercase text-white'>{t('enterTransactionPassword')}</h3>
            <p className='mb-4 text-sm font-normal normal-case leading-5 text-[var(--gray-40)]'>
              {t('enterTransactionPasswordHint')}
            </p>
            <input
              type='password'
              inputMode='numeric'
              autoComplete='one-time-code'
              maxLength={6}
              value={pin}
              className={FORM_CONTROL}
              placeholder='••••••'
              onChange={(event) => {
                setPin(String(event.target.value || '').replace(/\D/g, '').slice(0, 6))
                if (error) setError('')
              }}
            />
            {error && (
              <ErrorMessage
                className='mt-2 flex text-[var(--red)]'
                message={error}
              />
            )}
            <div className='mt-5 flex gap-3'>
              <GoldButton type='button' onClick={onClose} className='!bg-none !bg-[var(--gray-80)]'>
                {t('cancel')}
              </GoldButton>
              <GoldButton type='submit' disabled={submitting || pin.length !== 6}>
                {t('verify')}
              </GoldButton>
            </div>
          </form>
          )
        : (
          <div>
            <h3 className='mb-2 text-lg font-bold uppercase text-white'>{t('transactionPasswordNotSetTitle')}</h3>
            <p className='mb-5 text-sm font-normal normal-case leading-5 text-[var(--gray-40)]'>
              {t('transactionPasswordNotSetHint')}
            </p>
            <GoldButton
              type='button'
              onClick={() => {
                onGoToSettings(ROUTE_PATHS.SETTINGS)
              }}
            >
              {t('goToAccountSettings')}
            </GoldButton>
          </div>
          )}
    </CommonPopup>
  )
}

export default WithdrawTransactionPasswordModal
